import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 台帳種別のENUM */
enum LedgerType {
  faLedger = '1',
  cpLedger = '2',
  laContractLedger = '3',
  laArticleLedger = '4',
}

const nameConfig = {
  faLedger: new Map([[Locale.ja, '固定資産台帳']]),
  cpLedger: new Map([[Locale.ja, '建仮台帳']]),
  laContractLedger: new Map([[Locale.ja, 'リース契約台帳']]),
  laArticleLedger: new Map([[Locale.ja, 'リース物件台帳']]),
};

const toEnum = rawValueToEnum(LedgerType, LedgerType.laContractLedger);
const toDisplay = enumToName(LedgerType, nameConfig);
const toDisplayWithPrefix = enumToName(LedgerType, nameConfig, { prefix: true });

export const ledgerType = {
  enum: LedgerType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LedgerType };
